idName: 'transaction_id'<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Транзакции</h1>

    <resource-list
      url="/transactions"
      current-sort="text"
      resource-name="transactions"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'transactions',
  components: { resourceList },
  data () {
    return {
      fields: [
        { name: 'full_name', label: 'Клиент', sort: false },
        { name: 'amount', label: 'Сумма', sort: true, money: true },
        { name: 'transaction_type',
          label: 'Тип операции',
          sort: true,
          decorators: {
            classes: {
              'D': 'debit',
              'C': 'credit'
            },
            values: {
              'D': 'пополнение',
              'C': 'снятие'
            }
          }
        },
        { name: 'notation', label: 'Примечание', sort: true },
        { name: 'datetime', label: 'Дата и время', sort: true, datetime: true }
      ],
      filters: {
        client: ''
      },
      actionRoutes: [
        { name: 'transaction-details', idName: 'transaction_id', label: 'Открыть детали' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// Transactions.vue?7122b482